import React from 'react'

import { MarkdownTextContainer } from './MarkdownText.styled'

function MarkdownText({ text }: { text: string }) {
    function format(original: string) {
        const boldAndItalic = /\*\*\*(.*?)\*\*\*/gm
        const bold = /\*\*(.*?)\*\*/gm
        const italic = /\*(.*?)\*/gm

        return original
            .replace(boldAndItalic, '<b><i>$1</i></b>')
            .replace(bold, '<b>$1</b>')
            .replace(italic, '<i>$1</i>')
    }

    return (
        <MarkdownTextContainer>
            <span
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: format(text) }}
            />
        </MarkdownTextContainer>
    )
}

export default MarkdownText
